module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer011"
    }
  }, [_c('p', {
    staticClass: "author-bio"
  }, [_vm._v("Aris I. Xenofos was born on October 1st, 1963 in Kefalonia, the largest western island in Greece, located in the Ionian Sea, between Greece and Italy. In 1966 he moved with his parents to Zakynthos, an Ionian island to the south of Kefalonia where he stayed until the end of his elementary school years, before moving permanently to Athens.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Xenofos is married with two children. He is an economist in the profession, a former horse-riding athlete, and a Karate trainer.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The Little Raindrop")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" is his first children’s book inspired by his two sons.")])]), _vm._v(" "), _c('p', {
    staticClass: "Graphics- _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035841516_txt2.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Graphics- _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035841516_txt3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "copyright-heading"
  }, [_vm._v("Copyright © Aris Xenofos 2024")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The right of ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Aris Xenofos")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" to be identified as author of this work has been asserted by the author in accordance with sections 77 and 78 of the Copyright, Designs and Patents Act 1988.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("A CIP catalogue record for this title is available from the British Library.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("ISBN 9781035841516 (Paperback)")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("ISBN 9781035841523 (ePub e-book)")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("www.austinmacauley.com")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("First Published 2024")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Austin Macauley Publishers Ltd®")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("1 Canada Square")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Canary Wharf ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("London")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("E14 5AA")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("To my parents, for their lifetime support, guidance and affection.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("To my sons, Mario and Dimitri, for the inspiration and the motivation to write.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I would like to warmly thank my dear friend, Grania Kaleway, for her assistance and contribution in editing the English text.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I would also like to all-heartedly thank Austin Macauley Publishers for warmly embracing my work from the very beginning and for their professionalism, consistency, and guidance in making my first book reach publication.")])]), _vm._v(" "), _c('p', {
    staticClass: "text-with-indednt"
  }, [_vm._v("Once upon a time, so very high, up in the sky, there lived a Little Raindrop. She had the roundest face and beautiful fair pigtails, all caught up with a ribbon, as blue as the sky she lived in.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Every morning, as the Little Raindrop awoke, she would stretch her tiny body and she would begin to play. She loved to run, to sing, to dance and to dive in and out of her little cloud and to play hide and seek in its grey depths. When she became tired, she would rise once more to the surface and would sit herself on the top of her little cloud, and there she would wait for her friend the Sun to warm her cool little body. Then she would begin her game all over again from the beginning. But, most of all she loved to jump from one cloud to another and to feel herself travel through space.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("One day, however, she was not careful enough and when she jumped … hard as she tried, she just could not reach her little cloud, for the wind was too strong …")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("And she began to fall …")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("… down through space …")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("… She tried desperately to clutch onto something, to anything, as she fell, but her wet little hands were too slippery and she just continued to fall.")])]), _vm._v(" "), _c('p', {
    staticClass: "Graphics- _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035841516_txt7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-with-indednt"
  }, [_vm._v("Before she could draw breath, she had arrived with a splash on to the surface of the earth. She looked around herself and realised that she was completely alone – everything seemed so strange … so foreign. A sense of fear began to grow within her and she huddled herself up into a little ball.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“What I would not give to be able to return to the safety of my little grey cloud.” She sighed to herself.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Unbeknown to her however, one of her best friends was watching from afar – and upon realising what had befallen her dear friend, she began to call out for help … But no one could hear, her voice was carried away on the strong wind.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Powerless as I am …” whispered the little friend to herself, “… I must at least try to get close to my friend, The Little Raindrop.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("And with a leap, she jumped courageously into space to join her friend on the surface of the earth. But the earth was so large and the distance between her and The Little Raindrop so huge that she was unable to get close to The Little Raindrop. She began also to be as afraid as the Little Raindrop, and huddled herself up into a little ball to wait …")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("High up in the sky, on another little cloud, another friend was watching in agony and could clearly sense the palpable fear of The Little Raindrop. She takes the decision to jump also – and she, too falls through space and arrives with a ‘Splash’ on earth in between her two friends. She looks tenderly at them and bids them: “Do not be afraid. Because just before I jumped, I paid a visit to Mrs Thunder and asked her to spread the word, so very soon all our other little Raindrop friends will be joining us. I feel quite sure that if we are all together, we will be able to find a solution to our predicament.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Graphics- _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035841516_txt9.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-with-indednt"
  }, [_vm._v("Soon enough, all the other Raindrops began to fall from their clouds. So many Raindrops pitter-pattered down one after the other, that they very quickly began to get closer and closer to one another. Until very soon, they were all joined up together and able to feel safe once more. They joined hands in relief and slowly began to smile and laugh and sing. Such was their relief and their happiness that they began to flow in a most beautiful and joyous river of dance and fun. The river gathered speed and momentum and got larger and larger …")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("In the meantime, The Little Raindrop had completely forgotten the fear that had gripped her earlier, and sat on the very surface of the river, flowing down with peace in her heart on this new and exciting journey. She jumped onto the golden leaves of the old maple tree that were being dragged by the force of this river of joy and happiness. She gathered together the pink, and the yellow and the white petals of the little daisies that floated along beside her and when her arms were filled with margaritas of all the colours of the rainbow, she threw them up in the air like fireworks in celebration. Then she stretched out one hand to give the fluttering butterflies a place to rest. And with the other, she brushed away the bees armed with their sting, who came to drink at this river of joy.")])]), _vm._v(" "), _c('p', {
    staticClass: "Graphics- _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035841516_txt11.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text-with-indednt"
  }, [_vm._v("Her journey on the river flowed harmoniously and sweetly through a forest of a million hues of green. It flowed over the rocks and stones it encountered and then swept down deep to caress the riverbed with forceful intent. For a moment slowing its momentum to wet and wash each and every rock in its course, and to then gather speed once more as it began to make its rapid descent to lower land. All of a sudden, the soft harmonious joy that had pervaded her was replaced by fear, as the power of the water became so great and began to thrash and crash up against the banks of the river.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The Little Raindrop pulled herself up straight to stand firmly on her two round little legs. She rubbed her eyes and looked deep into the depths of the river, trying desperately to understand exactly what was happening. She could see water foaming, and broken branches tumbling and racing with the force of the water. She could see frightened butterflies that until just a second earlier had been happily dancing along to the rhythm of the water, but were now not only confused and fearful, but also searching frantically for a flower here or there on which to cling for safety. And then there was the strangest noise to be heard. A thunderous, menacing deep murmur that resonated all around.")])]), _vm._v(" "), _c('p', {
    staticClass: "Graphics- _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035841516_txt13.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text-with-indednt"
  }, [_vm._v("The Little Raindrop began to search for her Raindrop friends, and upon seeing them, instantly discerned that her fear was matched and shared only by their own anxiety and growing sense of uncertainty. She started to wave her arms in search of someone or something that would see and respond to her call for help.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Do not be afraid Little Raindrop,” came the reassuring words of one of her Raindrop friends, who grasping her firmly by the hand, added, “have I not always told you that when we are all together, we can make anything happen?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("With the other hand, she took hold of that of the next Little Raindrop, who in turn did the same to the next Little Raindrop that stood beside her. And then the next. And the next. Until all the Little Raindrops had formed a powerful chain of rain that would be their stave, whatever were to happen next.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("In the meantime, the river had grown and grown, drop on drop, Raindrop on Raindrop and swollen to frightening dimensions. The murmur had become a deep, and deafening sound. The strong wind beat against the little wet bodies of the Raindrops, and then all of a sudden – Silence, peace and harmony was restored once more. The Little Raindrop was no longer immersed in the river, the wind has ceased to beat against her little body, and had picked her up in his arms, and was now winging her onward on her journey.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The Little Raindrop lifted her head up high, looked back behind her, to see the river suddenly receding into the distance, and ahead of her, the immensity of the blue expanse of time and space. The Little Raindrop suddenly felt free, light and effervescent, and a smile broke out all over her face. She felt now just as she used to. Sitting up on her own little cloud – and yet she was not …")])]), _vm._v(" "), _c('p', {
    staticClass: "Graphics- _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035841516_txt15.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text-with-indednt"
  }, [_vm._v("Below her, there was an enormous lake that waited to embrace her … and it was then that she remembered the wise words of her grandmother. Words to describe a journey she had once made, many years ago in her youth, on a wild cataract. She returned to her friends – she looks, she smiles and she shouts for all the world to hear: “This is a cataract!!! Get ready now for the best dive ever of your life!” – And before she could barely finish her sentence, there they all found themselves drawn down by the force of the water and swimming in the translucent green lake. And there they began to play. Making little faces to the happy fish, as they swam, climbing onto the lotus flowers that surrounded them, and thus they began to sing. Their little faces reflected here and there in the shiny pebbles on the river bed which caressed the faces of the animals that came to drink, holding onto the feathers of the graceful and playful swan that were dancing in the translucent water with them.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Time passed and the game began to slow down, and as the light of day drew slowly to a soft twilight, the eyelids of the woods that surround them slowly begin to blink and to close. The Little Raindrop, totally exhausted by her adventures, drew herself onto the bank of the river to rest … There she finds the trunk of a huge old maple tree … she stretches out to it, and she touches it. She looks up, and sees the branches reaching, stretching up to the sky above. She feels almost as if they might touch the sky. And she begins to miss her little cloud once more. And thinks to herself that if she climbs up onto the highest branches, perhaps she will be able to travel all the way back home.")])]), _vm._v(" "), _c('p', {
    staticClass: "Graphics- _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035841516_txt17.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text-with-indednt"
  }, [_vm._v("The Little Raindrop turns towards the Old Maple Tree and asks if she might be allowed to step inside its huge hollow … She wants only to play and flow within the tree, and to reach to its highest branches. To reach up and touch the moon, that soft maternal friend of the sun.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The old maple tree wisely responds and knowingly says, “I know Little Raindrop how very much you miss your little grey cloud. And I want to help you return to it. But I need just one favour in return …”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I will do anything you ask Old Maple Tree, anything.” She responds with big round eyes …")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“You see,” said the Old Maple Tree, “my body is old and my leaves are lined and scarred with the signs of time, and I am in need of water. If you can reach up to my highest branches, and caress me with your soft wet hands, my body will be quenched of its terrible thirst, and I will be able to help you climb ever higher, to my very highest branch.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The Little Raindrop could not believe her ears. And thought to herself, can it possibly be so very simple … ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("She stepped into the hollow of the tree and began her journey up through the body of the old Maple tree. The body of the Maple was strong but so very dry from the sun and from the wind, and scarred by the ravages of time … The Little Raindrop caresses the bark of the tree with her soft wet touch, to continue her journey spreading from one cell of the tree to the next. The body of the tree began slowly to change colour. The dark brown bark softening and becoming lighter in colour, and slowly taking on a deep green hue. The trunk of the tree becomes more supple and moist with the love of the Raindrop, and slowly revives. The Little Raindrop that has now reached the very core of the trunk of the tree, discerns the light of the moon through a little crack, and rests in its soft gleaming beams. It is then that her gaze falls upon two words that have been inscribed once upon a time, many years ago, into the bark of the Old Maple Tree: ‘Your Grandmother’. It is then that the Little Raindrop begins to understand. She no longer feels alone. And now knows that one day, very soon, she will find the way back to her cloud.")])]), _vm._v(" "), _c('p', {
    staticClass: "Graphics- _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035841516_txt20.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text-with-indednt"
  }, [_vm._v("She continues her journey through the Old Maple Tree and begins to feel tired. Her little legs begin to crease up. Her eyelids become heavy and the light of the moon begins to flicker on and off as it plays the sweetest lullaby and she falls asleep in the arms of the maple leaf.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("It is dawn now. The first rays of sun stretch across her, and the black of night slowly dissipates. The horizon is painted with the most beautiful colours of peach, of orange, gold and red. The Sun, the king of light, makes his appearance, and begins to draw his golden carriage in the form of an arc across the sky. His light pours everywhere and warms the land, and its rays leave their brightest traces across the kingdom of the Earth.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The Little Raindrop is still asleep. And has not fully realised that one of the rays of sunlight is slowly creeping up to give her the warmest caress.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("As it does, it enshrouds the Little Raindrop with the most beautiful glow and the eyes of the Little Raindrop begin to open. She awakes. She looks all around and it is then that she begins to remember her adventurous journey. Her game with all her Raindrop friends in the river. The cataract. And the bark of the Old Maple Tree inscribed with the words: ‘Your Grandmother’. She looks up, she sees the little cloud …")])]), _vm._v(" "), _c('p', {
    staticClass: "Graphics- _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035841516_txt22.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text-with-indednt _idGenParaOverride-1"
  }, [_vm._v("It is then that something most strange comes to pass. She feels a sensation that she has never felt before. Her body, warm from the rays of the sun, begins to change form. She is no longer round nor cool as before. Her hands are changing shape and her little feet no longer touching the surface of the large maple leaf on which they stand. Her body is no longer heavy and she begins to feel an immense lightness of being. The sun is drawing her upwards. The distance from her little cloud is growing smaller by the minute. And before she knows it, she finds herself back in the grey midst of her little cloud. Her body begins to swell and she becomes soft and cool. She rises to the surface of her cloud and looking across the immensity of space, finds her good friend, the Sun. She winks knowingly at him and then she looks down to the Earth, and she smiles broadly. She has just at this very moment learned and fully understood that the game that once upon a time her grandmother taught her, was not just any game. It was the journey of life for a lifetime. A journey which she was destined to repeat, time and time, again …")]), _vm._v(" "), _c('p', {
    staticClass: "Graphics-"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035841516_txt24.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2220314a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled-1.vue
// module id = 57
// module chunks = 0